import { useEffect, useState } from "react";

// True once `ref`'s element is within one viewport of the screen (rootMargin 100%), then stays true. Always false in the
// prerender and on the first client render, so hydration matches and nothing heavy is requested before it's needed.
export function useNearViewport(ref, rootMargin = "100% 0px") {
  const [near, setNear] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (near || !el || window.__PRERENDER__) return undefined;
    if (!("IntersectionObserver" in window)) { setNear(true); return undefined; }
    const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { setNear(true); io.disconnect(); } }, { rootMargin });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, near, rootMargin]);
  return near;
}
